import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import * as Styled from './styles';

type WarningBannerProps = {
  message: string;
  isOpen: boolean;
  margin?: string;
};

export const WarningBanner = ({
  message = '',
  isOpen = false,
  margin = '0 0 2.5rem',
}: WarningBannerProps) => (
  <Styled.BannerWrapper>
    {isOpen && (
      <Styled.RequiredFieldsWarning margin={margin}>
        <FontAwesomeIcon icon={faTriangleExclamation} />
        <Styled.RequiredTextStyled>{message}</Styled.RequiredTextStyled>
      </Styled.RequiredFieldsWarning>
    )}
  </Styled.BannerWrapper>
);
